var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-preview", attrs: { id: "contents" } },
    [
      _c("job-preview-header-sp", {
        attrs: {
          "company-name": _vm.offer.companyInfo.name,
          title: _vm.offer.description.jobTitle,
          "is-simple": _vm.offer.description.isSimple,
          "is-original-entry-form": _vm.offer.description.isOriginalEntryForm,
          "employment-status": _vm.offer.description.employmentStatus,
        },
      }),
      _vm._v(" "),
      _c("job-preview-main-article-sp", {
        attrs: {
          "company-name": _vm.offer.companyInfo.name,
          title: _vm.offer.description.mainTitle,
          body: _vm.offer.description.mainBody,
          "photo-data": _vm.offer.description.mainPhoto,
          caption: _vm.offer.description.mainCaption,
          "pr-codes": _vm.offer.description.prCodes,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "blank-space" }),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        attrs: { id: "description", title: "仕事内容" },
      }),
      _vm._v(" "),
      _c("job-preview-description-sp", {
        attrs: { description: _vm.offer.description },
      }),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        staticClass: "mt20",
        attrs: { id: "require", title: "募集要項" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contents-inner" },
        [
          _c("job-preview-requirements-sp", {
            attrs: { requirements: _vm.offer.requirements },
          }),
          _vm._v(" "),
          _vm._l(_vm.getFreeTopics(_vm.offer, false), function (freeTopic, i) {
            return [
              _c("job-preview-free-topics-sp", {
                key: i,
                class: { mt20: i === 0 },
                attrs: { "free-topic": freeTopic },
              }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("job-preview-feature-sp", {
        attrs: { requirements: _vm.offer.requirements },
      }),
      _vm._v(" "),
      !_vm.offer.description.isLightPlan && _vm.offer.requirements.report.body
        ? _c("job-preview-view-points-sp", {
            attrs: {
              report: _vm.offer.requirements.report,
              interviews: _vm.getFreeTopics(_vm.offer, true),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.offer.realIntentions.length
        ? _c("job-preview-real-intention-sp", {
            attrs: {
              "company-name": _vm.offer.companyInfo.name,
              "real-intentions": _vm.offer.realIntentions,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        staticClass: "mt20",
        attrs: { id: "company", title: "会社概要" },
      }),
      _vm._v(" "),
      _c("job-preview-company-info-sp", {
        attrs: {
          "is-light-plan": _vm.offer.description.isLightPlan,
          "company-info": _vm.offer.companyInfo,
        },
      }),
      _vm._v(" "),
      _c("job-preview-section-title-sp", {
        staticClass: "mt20",
        attrs: { id: "application", title: "応募・選考" },
      }),
      _vm._v(" "),
      _c("job-preview-selection-sp", {
        attrs: {
          "company-name": _vm.offer.companyInfo.name,
          selection: _vm.offer.selection,
        },
      }),
      _vm._v(" "),
      _c("user-preview-menu-sp", {
        attrs: { titles: ["写真で見る", "社員インタビュー"] },
      }),
      _vm._v(" "),
      _vm.isShowEnvironment(_vm.offer.environment)
        ? _c("job-preview-data-for-job-sp", {
            attrs: {
              "company-name": _vm.offer.companyInfo.name,
              environment: _vm.offer.environment,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("job-preview-entry-button-sp", {
        attrs: {
          "is-simple": _vm.offer.description.isSimple,
          "is-original-entry-form": _vm.offer.description.isOriginalEntryForm,
        },
      }),
      _vm._v(" "),
      _vm.isShowEnvironment(_vm.offer.environment)
        ? [
            _c("div", { staticClass: "hide-msg mlr15 margin-top-1" }, [
              _vm._v(
                "\n      「データをすべて見る」を押下すると、以下の内容が表示されます。\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "company-environments mt20 mb20" },
              [
                _c("job-preview-data-for-company-sp", {
                  attrs: { environment: _vm.offer.environment },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }